import { render } from "./TabBasicDetail.vue?vue&type=template&id=29f841a0"
import script from "./TabBasicDetail.vue?vue&type=script&lang=js"
export * from "./TabBasicDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__